var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{on:{"click":_vm.generateSitemap}},[_vm._v("生成Sitemap")]),_vm._v(" "),(_vm.sitemapUrl)?_c('p',[_vm._v("Sitemap URL: "+_vm._s(_vm.sitemapUrl))]):_vm._e(),_vm._v(" "),(_vm.sitemapUrl)?_c('a',{attrs:{"href":_vm.sitemapUrl,"download":"sitemap.xml"}},[_vm._v("下载Sitemap")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bb34cd6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vue-sitemap.vue
// module id = null
// module chunks = 